import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLocale } from "../context/LocaleContext";

const TYPE_LABELS = {
  article: { en: "Article", es: "Artículo", nl: "Artikel" },
  recipe: { en: "Recipe", es: "Receta", nl: "Recept" },
  exercise: { en: "Exercise", es: "Ejercicio", nl: "Oefening" },
  sport: { en: "Sport", es: "Deporte", nl: "Sport" },
  muscle: { en: "Muscle", es: "Músculo", nl: "Spier" },
  body_system: { en: "Body system", es: "Sistema corporal", nl: "Lichaamssysteem" },
  goal: { en: "Goal", es: "Objetivo", nl: "Doel" },
  calculator: { en: "Tool", es: "Herramienta", nl: "Tool" },
  plan: { en: "Plan", es: "Plan", nl: "Plan" },
  product: { en: "Product", es: "Producto", nl: "Product" },
  page: { en: "Page", es: "Página", nl: "Pagina" },
};

export function ContentCard({ item, index = 0 }) {
  const { locale, lp, sp } = useLocale();
  const typeLabel = TYPE_LABELS[item.type]?.[locale] || item.type;
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.05, 0.3) }}
    >
      <Link
        to={lp(`/${sp(item.section)}/${item.slug}`)}
        data-testid={`content-card-${item.slug}`}
        className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:border-emerald-300 hover:shadow-lg"
      >
        <div className="relative aspect-[16/10] overflow-hidden bg-slate-100">
          {item.image ? (
            <img src={item.image} alt={item.title} loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          ) : null}
          <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-emerald-700 backdrop-blur">
            {typeLabel}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-5">
          <h3 className="font-heading text-lg font-bold leading-tight text-slate-900 transition-colors group-hover:text-emerald-700">
            {item.title}
          </h3>
          {item.excerpt && <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-slate-500">{item.excerpt}</p>}
        </div>
      </Link>
    </motion.div>
  );
}
